import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';

import { decryptResponse } from 'utils/token';

type AddDocumentToOperationProps = {
  operationId: string;
  documentId: string;
};

export const addDocumentToOperation =
  ({ operationId, documentId }: AddDocumentToOperationProps) =>
  async (dispatch: Dispatch) => {
    const body = { operationId, documentId };
    try {
      const { data } = await axiosV2.put(`/operations/document`, body);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
